import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_search_outlined = _resolveComponent("search-outlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_auto_complete = _resolveComponent("a-auto-complete")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_a_auto_complete, {
      class: "search",
      placeholder: "...",
      size: "large",
      value: _ctx.searchStr,
      onSearch: _ctx.filterSearchItems,
      onSelect: _ctx.filterSearchItems
    }, {
      options: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsProps, (item) => {
          return (_openBlock(), _createBlock(_component_a_select_option, {
            key: item.name
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_input, null, {
          suffix: _withCtx(() => [
            _createVNode(_component_search_outlined, {
              class: "certain-category-icon",
              style: {"color":"grey"}
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "onSearch", "onSelect"])
  ], 64))
}